import { render, staticRenderFns } from "./highlighted_text.vue.js?vue&type=template&id=7e0d0332!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./highlighted_text.vue?vue&type=template&id=7e0d0332"
import script from "./highlighted_text.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./highlighted_text.vue?vue&type=script&lang=js"
export * from "./highlighted_text.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./highlighted_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports